import styled from "@emotion/styled";
import { FunctionComponent, ReactNode } from "react";

interface Props {
  children?: ReactNode;
  size?: 16 | 18 | 20 | 22 | 24;
}

export const TypoGraphy: FunctionComponent<Props> = ({ children, size }) => (
  <Style size={size}>{children}</Style>
);
const Style = styled.p<Props>`
  font-size: ${({ size }) => `${size}px`};
`;
